module.exports = {
  DefaultDashboard: 'Панель по умолчанию',
  Edit: 'Редактировать',
  PleaseSelectABranch: 'Выберите филиал',
  PleaseSelectADepartment: 'Выберите отдел',
  PleaseChooseDepartmentPersonnel: 'Выберите сотрудника отдела',
  BIDashboardSource: 'Источник BI-панели',
  SelectBIDashboardSource: 'Выберите источник BI-панели',
  BiExpiredTip: 'Уважаемый пользователь, срок действия приобретенного вами BI-модуля истек.<br>Для продолжения использования необходимо продлить подписку. Вы можете связаться с вашим продавцом или службой поддержки.<br><div style="margin-top: 5px;">Доступ к BI-модулю будет ограничен, но ваши данные сохранятся. После продления подписки вы сможете снова им пользоваться.</div>'
}
